"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMON_PAGE_SIZE_OPTIONS = exports.DEFAULT_COUNT = exports.DEFAULT_PAGE = exports.DEFAULT_PAGE_SIZE = void 0;
exports.DEFAULT_PAGE_SIZE = 20;
exports.DEFAULT_PAGE = 1;
exports.DEFAULT_COUNT = 0;
// eslint-disable-next-line no-magic-numbers
exports.COMMON_PAGE_SIZE_OPTIONS = [10, 20, 100];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcGFnaW5hdGlvbi9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRVUsUUFBQSxpQkFBaUIsR0FBRyxFQUFFLENBQUM7QUFDdkIsUUFBQSxZQUFZLEdBQUcsQ0FBQyxDQUFDO0FBQ2pCLFFBQUEsYUFBYSxHQUFHLENBQUMsQ0FBQztBQUMvQiw0Q0FBNEM7QUFDL0IsUUFBQSx3QkFBd0IsR0FBRyxDQUFDLEVBQUUsRUFBRSxFQUFFLEVBQUUsR0FBRyxDQUFDLENBQUMifQ==